<template>
  <v-col cols="12" lg="6" class="py-0 px-2 px-md-0">
    <v-row class="filter-base" dense>
      <div class="filter-base__label-container pr-2 pt-md-4">
        <div class="subtitle-1 d-inline">{{ label }}:</div>
        <div v-if="showToggletip" class="d-inline">
          <Toggletip
            class="filter-base__toggletip"
            :width="250"
            :activator-label="toggletipActivatorLabel"
          >
            <span>{{ toggletipText }}</span>
          </Toggletip>
        </div>
      </div>
      <v-col cols="12" :md="true">
        <slot></slot>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import Toggletip from "~/components/page/components/toggletip/Toggletip.vue";

export default {
  name: "FilterBase",
  components: { Toggletip },
  props: {
    label: { type: String, default: "" },
    toggletipText: { type: String, default: "" },
    toggletipActivatorLabel: { type: String, default: "" },
    showToggletip: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss">
.filter-base {
  &__label-container {
    text-align: right;
    @include media-breakpoint-up("md") {
      min-width: 125px;
    }
  }

  &__toggletip {
    text-align: left;
  }
}
</style>
